'use client'
import type { Props } from '../product-card-gallery'
import ProductCardGalleryWithSideButtons from './product-card-gallery-with-sideButtons'
import { useResponsive } from '@dustin-web/microsite-components/src/hooks'

export default function Container(props: Props) {
  const { breakpoints } = useResponsive()
  return <ProductCardGalleryWithSideButtons {...props} breakpoints={breakpoints} />
}
